class AppConfig {
    get bundleEnv() {
        return import.meta.env.PROD ? 'production' : 'development';
    }

    get appId() {
        return import.meta.env.RIA_APP_ID || 'oneview-viewtrade-verum';
    }

    get appVariant() {
        return import.meta.env.RIA_APP_VARIANT || 'advisor';
    }

    get appEnv() {
        return import.meta.env.RIA_APP_ENV || 'development';
    }

    get commitHash() {
        return import.meta.env.RIA_COMMIT_HASH || 'development';
    }

    get appBuildNumber() {
        return import.meta.env.RIA_APP_BUILD_NUMBER || '10000';
    }

    get appVersion() {
        return __APP_VERSION__;
    }

    get dataRefreshInterval() {
        return Number(import.meta.env.RIA_DATA_REFRESH_INTERVAL || '60000');
    }

    get dataRefreshIntervalLong() {
        return Number(import.meta.env.RIA_DATA_REFRESH_INTERVAL_LONG || '300000');
    }

    get dataRefreshIntervalShort() {
        return Number(import.meta.env.RIA_DATA_REFRESH_INTERVAL_SHORT || '5000');
    }

    get resourceBackground(): string[] {
        return JSON.parse(import.meta.env.RIA_RESOURCE_BACKGROUNDS || '[]');
    }

    get advisorCompanyLogo(): string {
        return import.meta.env.RIA_ADVISOR_COMPANY_LOGO || '/assets/images/logos/default-advisor-logo.png';
    }

    get clientCompanyLogo(): string {
        return import.meta.env.RIA_CLIENT_COMPANY_LOGO || '/assets/images/logos/default-client-logo.png';
    }

    get companyCopyright() {
        return import.meta.env.RIA_COMPANY_COPYRIGHT || '';
    }

    get newsLimit() {
        return Number(import.meta.env.RIA_NEWS_LIMIT || '40');
    }

    get defaultRowsPerPage() {
        return JSON.parse(import.meta.env.RIA_APP_DEFAULT_ROWS_PER_PAGE || '[10, 20, 30, 40, 50, 100, 500, 1000]');
    }

    get photoAcceptTypes(): string[] {
        return JSON.parse(import.meta.env.RIA_PHOTO_ACCEPT_TYPES || '["image/png", "image/jpeg", "image/jpg"]');
    }

    get photoMaxSizeInBytes(): number {
        return Number(import.meta.env.RIA_PHOTO_MAX_SIZE_IN_BYTES || '10485760');
    }

    get photosUploadLimit(): number {
        return Number(import.meta.env.RIA_PHOTOS_LIMIT || '10');
    }

    get documentAcceptFormats(): string[] {
        return JSON.parse(
            import.meta.env.RIA_DOCUMENT_ACCEPT_FORMATS ||
                '[".txt", ".doc", ".docx", ".odt", ".rtf", ".pdf", ".xls", ".xlsx", ".csv", ".ods", ".jpg", ".jpeg", ".png", ".heif"]',
        );
    }

    get documentSizeUploadLimit(): number {
        return Number(import.meta.env.RIA_DOCUMENT_SIZE_LIMIT || '50');
    }

    get fractionalSharePrecision() {
        return Number(import.meta.env.RIA_FRACTIONAL_SHARE_PRECISION || '5');
    }

    get chartingLibraryPath() {
        return import.meta.env?.RIA_CHARTING_LIBRARY_PATH || '/charting/';
    }

    get ssoPlatformUma() {
        return import.meta.env.RIA_SSO_PLATFORM_UMA || 'uma';
    }

    /**
     * @description The source of the quotes to use valid values are 'watchmen' or 'midas'
     * @default 'watchmen'
     */
    get quoteSource(): string {
        return import.meta.env.RIA_QUOTE_SOURCE || 'watchmen';
    }

    /**
     * @description Whether to show the changelog dialog
     * @default false
     */
    get showChangelog(): boolean {
        return import.meta.env.RIA_SHOW_CHANGELOG === 'true';
    }
}

const appConfig = new AppConfig();

export { appConfig };
